import React from 'react';
import {connect} from 'react-redux';
import {BaseFilterComponent} from 'components/organisms/used-players-list/components/filter/sports/lol/classic';

class FilterComponent extends BaseFilterComponent {
    render() {
        const tabs = this.prepareTabs();
        return <div className="tabs-chk-holder">{tabs}</div>;
    }
}

function mapStatesToProps(state) {
    return {
        modesConfig: state.modesConfig,
        sportConfig: state.sportConfig,
        filters: state.usedPlayers.filters,
    };
}

const Filter = connect(mapStatesToProps)(FilterComponent);

export {Filter};
